import { eventBus, EVENTS } from './commons/EventBus.js';
import Utils from './commons/utils.js';


eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;
    if(template!='playlist'){
        return;
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;


    $('input[name="playlist_date"]').daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        maxDate: today,
        "locale": Utils.SETTINGS.DATERANGEPICKER
    }, function(start, end, label) {
    });

    $('input[name="playlist_date"]').on('apply.daterangepicker', function (ev, picker) {
        let dateString=$(this).val();
        dateString=dateString.split('/').reverse().join('');
        addNavigation(`/musica/archivio-playlist/${dateString}`);
    });
  });
  $(document).on('click','.scopri_orizzontale_blue',function(){
    $('#playlist-playlist_songs').toggleClass('show-all');
    if($('#playlist-playlist_songs').hasClass('show-all')){
      $(".testo_show_more").text("Mostra di meno");
      $(".icon_show_more").addClass("show_less");
    }else{
  
      $(".testo_show_more").text("Mostra di più");
      $(".icon_show_more").removeClass("show_less");
    }
  });
  $(document).on('click','#calendario_playlist',function(){
      $('input[name="playlist_date"]').trigger("click");
  });




